import { IComponentOptions } from 'angular';
import { MasterProgramTableCtrl } from './master-program-table.controller';

export const MasterProgramTableComponent: IComponentOptions = {
  template: require('./master-program-table.html'),
  bindings: {
    masterProgram: '=',
    subjectAreas: '<',
    teachers: '=',
    courseFilter: '<',
    currentSchool: '=',
    prepCourses: '<',
    selectedCourses: '=',
    filterCourseCodeWithSection: '=',
  },
  controller: MasterProgramTableCtrl,
};

angular.module('nv.SchoolMetricsModule').component('masterProgramTable', MasterProgramTableComponent);
